import { Box,Button,Flex,Select,InputGroup,
  InputLeftElement,Input, Text, 
  TableContainer,Table,Thead,Tbody,Th,Tr,Td,Grid,GridItem, Checkbox, 
  Spinner,
  Textarea,InputRightElement,
  Stack} from "@chakra-ui/react";
import { TopDisplay } from "../../../../components";
import { IoMdAdd as AddIcon } from "react-icons/io";
import { LuSearch as SearchIcon } from "react-icons/lu";
import { useState, useEffect } from "react";
import { useMutation, useQuery, useQueryClient } from 'react-query';
import styled from "@emotion/styled";
import { atom, useAtom } from 'jotai';
import apiCall from '../../../../utils/apiCall';
import {TopLink} from '../';
import {openAtom,modalAtom,openNAtom,notificationAtom} from '../../../../context';
import { Formik,Form,Field } from "formik";
import {TablePopUp} from '../../../../components';
import * as Yup from 'yup';
import { format } from "date-fns";
import { Loader } from "../../../../customs";
import ReactPaginate from "react-paginate";
import { TbReload as ReloadIcon } from "react-icons/tb";
import { AxiosError } from "axios";

// const allRescheduleExam = [
//   {
//     Id:Math.floor(Math.random() * 10000)+1,
//     ExamId:'12345',
//     SubjectName:'Internet of things',
//     Level:'2',
//     CutOffMark: '50',
//     Amount:'300,000'
//   },
//   {
//     Id:Math.floor(Math.random() * 10000)+1,
//     ExamId:'12345',
//     SubjectName:'Internet of things',
//     Level:'2',
//     CutOffMark: '50',
//     Amount:'300,000'
//   },
//   {
//     Id:Math.floor(Math.random() * 10000)+1,
//     ExamId:'12345',
//     SubjectName:'Internet of things',
//     Level:'2',
//     CutOffMark: '50',
//     Amount:'300,000'
//   } ,
//   {
//     Id:Math.floor(Math.random() * 10000)+1,
//     ExamId:'12345',
//     SubjectName:'Internet of things',
//     Level:'2',
//     CutOffMark: '50',
//     Amount:'300,000'
//   },
//   {
//     Id:Math.floor(Math.random() * 10000)+1,
//     ExamId:'12345',
//     SubjectName:'Internet of things',
//     Level:'2',
//     CutOffMark: '50',
//     Amount:'300,000'
//   }  
// ]

const HeadStyle={
  borderBottom:"1px solid var(--dark-green-color)",
  padding:'15px 5px',
}
const DataStyle = {
  padding:'5px 5px',
}


const ROWSTYLE = styled.tr`
  & > td:last-of-type > *{
    display:none;
  }
  :hover > td{
    background-color:var(--table-highlight);
    &:last-of-type > *{
      display:block;
    }
  } 
  &.active > td:last-of-type > *{
    display:block !important;
  }  
`

const RescheduleExamAtom = atom<number | null>(null);


export default function RescheduleExam() {
  const [hide,set_hide] = useState<boolean>(true);
  const [,set_modal] = useAtom(modalAtom);
  const [,set_open] = useAtom(openAtom);
  const [active] = useAtom<number | string | null>(RescheduleExamAtom);
  const [,set_period] = useState('');

  const {data:allExamPeriod} = useQuery(['exam-period'],{
    queryFn:async ()=> await apiCall().get(`exam/setup/examPeriod`),
    select(data){
      return data.data.Data;
    },
  })
   const {data:allExamSubject} = useQuery(['exam-subject'],{
    queryFn:async ()=> await apiCall().get(`exam/setup/examSubject`),
    select(data){
      return data.data.Data;
    },
  })


  const {isLoading,data:allRescheduleExam} = useQuery(['exam-reschedule'],{
    queryFn:async ()=> await apiCall().get(`/Exam/rescheduled-exams`),
    select(data){
      return data.data.Data;
    }
  })
  const [search,set_search] = useState('');

  const [filter_data, set_filter_data] = useState<any[]>(allRescheduleExam);
  
  const handleSearch = (e: any) => {
    let val = e.target.value;
    set_search(val);
  
    if (val) {
      let new_data = allRescheduleExam?.filter((eData: any) =>
        eData.StudentMembershipNo && eData.StudentMembershipNo.toLowerCase().includes(val.toLowerCase())
      );
  
      if (new_data.length > 0) {
        set_filter_data(new_data);
      } else {
        set_filter_data([]); // Set to empty array to indicate "Not found"
      }
    } else {
      set_filter_data(allRescheduleExam); // Reset to full data if search is cleared
    }
  };
  
  
  const itemsPerPage = 10;
  const [itemOffset, setItemOffset] = useState(0);
  const endOffset = itemOffset + itemsPerPage;
  console.log(`Loading items from ${itemOffset} to ${endOffset}`);
  const currentItems = filter_data?.slice(itemOffset, endOffset);
  const pageCount = Math.ceil(filter_data?.length / itemsPerPage);
  const handlePageClick = (event:any) => {
    const newOffset = (event.selected * itemsPerPage) % filter_data?.length;
    console.log(
      `User requested page number ${event.selected}, which is offset ${newOffset}`
    );
    setItemOffset(newOffset);
  };
  useEffect(()=>{
    set_filter_data(allRescheduleExam)
  },[allRescheduleExam])

  const handleAddResheduleExam = () =>{
    set_modal({
      header:'Reschedule Exam',
      content:<AddType />
    })
    set_open(true);
}

  return (
    <> 
    {isLoading?<Loader />:
    <Box>
      <TopLink />
      <TopDisplay label="Reschedule Exam" button_array={[
          <Button onClick={handleAddResheduleExam} bg="var(--dark-green-color)" color="var(--white-color)"  type="button"  leftIcon={<AddIcon/>}>Reschedule Exams</Button>
        ]} />
        <Flex  gap="20px" wrap="wrap" mt="20px">
        <InputGroup width="250px" bg="var(--white-color)" borderColor="var(--dark-green-color)">
            <InputLeftElement pointerEvents='none'>
              <SearchIcon color='gray.300' />
            </InputLeftElement>
            <Input value={search} onChange={handleSearch} type='text' placeholder='search' />
            <span style={{position:'absolute',zIndex:'1',
            right:'10px',cursor:'pointer',top:'12px'}}><ReloadIcon /></span>
          </InputGroup>
          {/* <Select placeholder="Active diet" width="150px" bg="var(--white-color)" borderColor="var(dark-green-color)" onChange={(e:any)=>set_period(e.target.value)}>
            {allExamPeriod && allExamPeriod?.length > 0 ?allExamPeriod?.map((ePeriod:any)=>
            <option key={ePeriod?.Id} value={ePeriod?.Id}>{ePeriod?.ExamName}</option>
          ):''}
          </Select> */}
          

        </Flex>
        <Flex mt="25px" flexDir="column" gap="10px">
        <Text m="0" fontSize="1rem">All Rescheduled Exams</Text>
          <Text m="0" fontSize=".8rem">showing {itemOffset} - {itemOffset + itemsPerPage > filter_data?.length?filter_data?.length:endOffset} of {filter_data?.length}</Text>
        </Flex>
     {filter_data && filter_data.length > 0 ? <TableContainer mt="20px">
          <Table size='sm'>
            <Thead>
              <Tr >
                <Th sx={HeadStyle}>Student No</Th>
                <Th sx={HeadStyle}>From Diet</Th>
                <Th sx={HeadStyle}>To Diet</Th>
                <Th sx={HeadStyle}>Subjects</Th>
                <Th sx={HeadStyle}>Date Rescheduled</Th>
                <Th sx={HeadStyle}>Reason</Th>
                <Th sx={HeadStyle} w="50px"></Th>
              </Tr>
            </Thead>
            <Tbody>
              {currentItems.map((eRescheduleExam:any) =><ROWSTYLE key={eRescheduleExam.StudentMembershipNo} className={eRescheduleExam.StudentMembershipNo === active?'active':''}>
                <Td sx={DataStyle}>{eRescheduleExam.StudentNo}</Td>
                <Td sx={DataStyle}>{allExamPeriod && allExamPeriod.find((ePeriod:any)=> ePeriod.Id == eRescheduleExam.RescheduleFromExamPeriodId)?.ExamName || 'N/A'}</Td>
                <Td sx={DataStyle}>{allExamPeriod && allExamPeriod.find((ePeriod:any)=> ePeriod.Id == eRescheduleExam.RescheduleToExamPeriodId)?.ExamName || ''}</Td>
                <Td sx={DataStyle}>{allExamSubject && allExamSubject.find((eSub:any) => eSub.Id == eRescheduleExam.SubjectId)?.Name || ''}</Td>
                <Td sx={DataStyle}>{format(new Date(eRescheduleExam.DateRescheduled), "dd/MM/yyyy")}</Td>
                <Td sx={DataStyle}>{eRescheduleExam.Reason}</Td>
                <Td sx={DataStyle} w="50px" h="50px">
                  <TempPopUp index={eRescheduleExam.StudentMembershipNo} data={eRescheduleExam}/>
                </Td>
              </ROWSTYLE>
              )}
            </Tbody>
          </Table>
        </TableContainer>
        :'No Rescheduled Exams'  
      }
      <StylePaginateBox>
        <ReactPaginate
          breakLabel="..."
          nextLabel=">"
          onPageChange={handlePageClick}
          pageRangeDisplayed={5}
          pageCount={pageCount}
          previousLabel="<"
          renderOnZeroPageCount={null}
        />

      </StylePaginateBox>

    </Box>
}
    </>
   
  )
}
const StylePaginateBox = styled.div`
  width:100%;
  & > ul{
    list-style-type: none;
    text-align:center;
    padding:0;
    margin:0;
    margin-top:10px;
  } 
  & > ul > li{
    display: inline;
    margin:0 5px;
    padding:2px 5px;
    border-radius: 3px;
    background-color: transparent;
    color:var(--dark-green-color);
  }
  & > ul > li.selected{
    background-color: var(--highlight-paginate-background);
    color:var(--highlight-paginate-color);
  }
  & > ul > li:first-of-type,
  & > ul > li:last-of-type{
    font-weight: bold;
  }
`

const Label = styled.label``; 

const AddSchema = Yup.object({
  StudentNo: Yup.string().required('Student number is required'),
  ActiveDiet: Yup.number().required('Active Diet is required'),
  Reason: Yup.string(),
});

const AddType = (props: any) => { 
  const queryClient = useQueryClient();
  const [, set_open] = useAtom(openAtom);
  const [, set_Nopen] = useAtom(openNAtom);
  const [, set_notification] = useAtom(notificationAtom);
  const [studentNo, setStudentNo] = useState<string>('');
  const [errorMessage, setErrorMessage] = useState('');
  const [tempStudentNo, setTempStudentNo] = useState(''); // Hold temporary input value
  const [selectedSubjects, setSelectedSubjects] = useState<string[]>([]);

  const { data: allExamPeriod } = useQuery(['exam-period'], {
    queryFn: async () => await apiCall().get(`exam/setup/examPeriod`),
    select(data) {
      return data.data.Data;
    },
  });

  const {data:allExamSubject} = useQuery(['exam-subject'],{
    queryFn:async ()=> await apiCall().get(`exam/setup/examSubject`),
    select(data){
      return data.data.Data;
    },
  })

  interface ApiErrorResponse {
    Message: string;
  }

  const { data: studentData, refetch: fetchStudentData, isFetching: isFetchingStudent, error } = useQuery(
    ['fetchStudentData', studentNo],
    async () => {
      const response = await apiCall().get('/Exam/examReschedule', {
        params: { studentNo },
      });
      //console.log("Student Data:", response.data); // Add this line to inspect the response structure
      return response.data;
    },
    {
      enabled: false, // Only fetch when triggered
      onError: (err: any) => {
        setErrorMessage(
          err?.response?.data?.Message || 'Error fetching data. Please check the student number.'
        );
      },
      onSuccess: (data) => {
        if (!data || !data.Level) {
          setErrorMessage('No student found.');
        } else {
          setErrorMessage('');
        }
      },
    }
  );

  const { isLoading, mutate: addUpdate } = useMutation(
    async (data: any) => await apiCall().post(`/Exam/examReschedule`, data),
    {
      onSuccess: (data) => {
        set_notification({
          type: 'success',
          message: data?.data?.Message || 'Exam Rescheduled Successfully',
        });
        set_Nopen(true);
        queryClient.invalidateQueries(['exam-reschedule']);
      },
      onError: (error: any) => {
        set_notification({
          type: 'error',
          message: error?.response?.data?.Message || 'Error Occurred',
        });
        set_Nopen(true);
      },
      onSettled: () => {
        set_open(false);
      },
    }
  );

  const handleFetchClick = () => {
    if (tempStudentNo) {
      setStudentNo(tempStudentNo); 
      fetchStudentData(); 
    } else {
      setErrorMessage('Please enter a valid student number.');
    }
  };

  const handleStudentNoChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setTempStudentNo(e.target.value);
  };

  const handleSubjectSelection = (e: React.ChangeEvent<HTMLInputElement>, subjectId: string) => {
    const { checked } = e.target;
    setSelectedSubjects((prevSelectedSubjects) => {
      if (checked) {
        return [...prevSelectedSubjects, subjectId];
      } else {
        return prevSelectedSubjects.filter(id => id !== subjectId);
      }
    });
  };
  

  return (
    <Formik
    initialValues={{
      StudentNo: '',
      RescheduleFromExamPeriodId: '', 
      RescheduleToExamPeriodId: '', 
      ActiveDiet: '',
      Reason: '',
    }}
    validationSchema={AddSchema}
    onSubmit={(values: any) => {
      const data = {
        StudentNo: values.StudentNo,
        RescheduleFromExamPeriodId: studentData?.Data?.ExamPeriodId || "",
        RescheduleToExamPeriodId: values.ActiveDiet, 
        ExamSubjectIds: selectedSubjects,
        Reason: values.Reason,
      };
      addUpdate(data);
    }}
  >
    {(formik) => {
      const { values, setFieldValue } = formik;
  
      return (
        <Form>
          <Flex flexDir="column" align="center" gap="20px">
            {/* Student Number Input with Fetch Button */}
            <InputGroup>
              <Field
                as={Input}
                bg="var(--white-color)"
                borderColor="var(--dark-green-color)"
                color="var(--dark-green-color)"
                placeholder="Student / Member ID"
                name="StudentNo"
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                  setFieldValue("StudentNo", e.target.value);
                  handleStudentNoChange(e);
                }}
              />
              <InputRightElement width="4.5rem">
                <Button h="1.75rem" size="sm" bg="var(--highlight-green)"
              color="var(--white-color)" onClick={handleFetchClick}>
                  Check
                </Button>
              </InputRightElement>
            </InputGroup>
  
            {isFetchingStudent && <Spinner />}
            {!isFetchingStudent && errorMessage && !studentData?.Data && (
              <Text color="red.500">{errorMessage}</Text>
            )}

        {studentData?.Data && (
        <Box 
          mt={4} 
          p={3} 
          bg="gray.100" 
          borderRadius="md" 
          w="100%" 
          border="2px solid" 
          borderColor="green.500"
        >
          {/* Display Level and ExamPeriod */}
          <Text fontWeight="bold" mb={1}>
            Level: <span style={{ fontWeight: 'normal' }}>{studentData.Data.Level || 'No level data available'}</span>
          </Text>
          <Text fontWeight="bold" mb={1}>
            Exam Period: <span style={{ fontWeight: 'normal' }}>{studentData.Data.ExamPeriod || 'No exam period data available'}</span>
          </Text>
          
          <Text fontWeight="bold" mb={1}>Subjects:</Text>
          <Stack spacing={2} pl={4}>
            {Array.isArray(studentData.Data.Subjects) && studentData.Data.Subjects.length > 0 ? (
              studentData.Data.Subjects.map((subject: any) => (
                <Checkbox
                  key={subject.ExamSubject.Id}
                  value={subject.ExamSubjectId}
                  isChecked={selectedSubjects.includes(subject.ExamSubjectId)}
                  onChange={(e) => handleSubjectSelection(e, subject.ExamSubjectId)}
                  borderColor="green.500" 
                  iconColor="green.500" 
                  colorScheme="green" 
                >
                  {subject.ExamSubject.Name || 'Unnamed Subject'}
                </Checkbox>
              ))
            ) : (
              <Text>No subjects found for this student.</Text>
            )}
          </Stack>
        </Box>
      )}



            {/* Active Diet Dropdown */}
            <Field as={Select} name="ActiveDiet" placeholder="Active Diet">
              {Array.isArray(allExamPeriod) && allExamPeriod.length > 0 ? (
                allExamPeriod.map((eType: any) => (
                  <option key={eType.Id} value={eType.Id}>
                    {eType.ExamName}
                  </option>
                ))
              ) : (
                <option value="">No data available</option>
              )}
            </Field>
  
            <Box fontWeight="500">Reasons</Box>
            <Textarea
              placeholder="Reason"
              resize="vertical"
              size="sm"
              onChange={(e) => setFieldValue("Reason", e.target.value)}
            />
  
            {/* Submit Button */}
            <Button
              disabled={isLoading}
              type="submit"
              bg="var(--dark-green-color)"
              color="var(--white-color)"
            >
              {isLoading ? 'Loading' : 'Submit'}
            </Button>
          </Flex>
        </Form>
      );
    }}
  </Formik>
  
  )
}

const TempPopUp = (props:any) =>{
  const index = props.index;
  const data = props.data;
  // console.log(data,'data')
  const [active,set_active] = useAtom(RescheduleExamAtom);
  const [,set_open] = useAtom(openAtom);
  const [,set_modal] = useAtom(modalAtom);
  const [,set_Nopen] = useAtom(openNAtom);
  const [,set_notification]= useAtom(notificationAtom);
  const queryClient = useQueryClient();

  const {data:allExamSubject} = useQuery(['exam-subject'],{
    queryFn:async ()=> await apiCall().get(`exam/setup/examSubject`),
    select(data){
      return data.data.Data;
    },
  })

  const {data:allExamPeriod} = useQuery(['exam-period'],{
    queryFn:async ()=> await apiCall().get(`exam/setup/examPeriod`),
    select(data){
      return data.data.Data;
    },
  })
  

  const handleClick = () =>{
    if(index === active){
      set_active(null);
      return;
    }
    else{
      set_active(index);
    }
  }
  const handleView= () =>{
    set_modal({
      header:'View Reschedule Exams',
      content: (
        <Grid templateColumns="200px 1fr" gap={4} p="10px">
          <GridItem as={Flex} alignItems="center">
            <Text fontWeight="bold">Student No:</Text>
          </GridItem>
          <GridItem as={Flex} alignItems="center">
            <Text>{data?.StudentNo || 'N/A'}</Text>
          </GridItem>
      
          <GridItem as={Flex} alignItems="center">
            <Text fontWeight="bold">Diet Rescheduled from:</Text>
          </GridItem>
          <GridItem as={Flex} alignItems="center">
            <Text>{allExamPeriod?.find((ePeriod: any) => ePeriod.Id == data?.RescheduleFromExamPeriodId)?.ExamName || 'N/A'}</Text>
          </GridItem>
      
          <GridItem as={Flex} alignItems="center">
            <Text fontWeight="bold">Diet Rescheduled to:</Text>
          </GridItem>
          <GridItem as={Flex} alignItems="center">
            <Text>{allExamPeriod?.find((ePeriod: any) => ePeriod.Id == data?.RescheduleToExamPeriodId)?.ExamName || 'N/A'}</Text>
          </GridItem>
      
          <GridItem as={Flex} alignItems="center">
            <Text fontWeight="bold">Subject:</Text>
          </GridItem>
          <GridItem as={Flex} alignItems="center">
            <Text>{allExamSubject?.find((eSub: any) => eSub.Id == data?.SubjectId)?.Name || 'N/A'}</Text>
          </GridItem>
      
          <GridItem as={Flex} alignItems="center">
            <Text fontWeight="bold">Date Rescheduled:</Text>
          </GridItem>
          <GridItem as={Flex} alignItems="center">
           <Text>{data.DateRescheduled ? format(new Date(data.DateRescheduled), "dd/MM/yyyy") : 'N/A'}</Text>
          </GridItem>
          <GridItem as={Flex} alignItems="center">
            <Text fontWeight="bold">Reason:</Text>
          </GridItem>
          <GridItem as={Flex} alignItems="center">
            <Text>{data?.Reason || 'N/A'}</Text>
          </GridItem>
        </Grid>
      )
      
    })
    set_open(true);
    handleClick();
  }
  // const handleEdit = () =>{
  //   handleClick();
  //   set_modal({
  //     header:'Edit Exam TimeTable',
  //     content:<AddType {...data}/>
  //   });
  //   set_open(true);
  //   handleClick();
    
  // }
  // const handleDelete = () =>{
  //   set_modal({
  //     header:'Delete Exam TimeTable',
  //     content:<Grid gap="20px">
  //       <GridItem>Are you Sure you want to delete this Exam Time Table?</GridItem>
  //       <GridItem as={Flex} justify="space-between" p="20px 0">
  //         <Button disabled={isLoading} onClick={()=>deleteFee()} bg="var(--dark-green-color)"
  //           color="var(--white-color)" >{isLoading?'Loading':'Delete'}</Button>
  //         <Button disabled={isLoading} 
  //           variant="outline" bg="var(--white-color)"
  //           onClick={()=>set_open(false)}
  //           border="1px solid var(--dark-green-color)"
  //           color="var(--dark-green-color)" >Cancel</Button>
  //       </GridItem>
  //     </Grid>
  //   });
  //   set_open(true);
  // }
  
  return (
    <TablePopUp click={handleClick} options={[
      {label:'View Rescheduled Exams',click:handleView},
      // {label:'Edit Exam TimeTable',click:handleEdit},
      // {label:'Delete Exam TimeTable',click:handleDelete}
    ]} />
  )
}

